import mladaKlasikaLogo from "./smklasika.png";
import mladaKreativaLogo from "./smkreativa.png";
import glasbaMladihLogo from "./smglasbamladih.png";
import gostujeLogo from "./smagostu.png";
import kulturaLogo from "./kulturaVAtriju.png";

export const cikli = {
    "mlada klasika": {
        ime: "Mlada Klasika",
        logo: mladaKlasikaLogo,
    },
    "mlada kreativa": {
        ime: "Mlada Kreativa",
        logo: mladaKreativaLogo,
    },
    "glasbaMladih": {
        ime: "glasbaMladih",
        logo: glasbaMladihLogo,
    },
    "gostuje": {
        ime: "Gostuje",
        logo: gostujeLogo,
    },
    "kultura v atrijih": {
        ime: "Kultura v atrijih",
        logo: kulturaLogo,
    }
};
